import { gsap } from 'gsap';

export class FadeInLetteringEffect {

	container: HTMLElement;

	constructor( el: HTMLElement ) {

		this.container = el;

		const delay = ( this.container.dataset.effectDelay ? this.container.dataset.effectDelay : 0 );

		const text = this.container.innerText;
		const spans = [];
		for ( let i = 0; i < text.length; i++ ) {
			spans.push( '<span>' + text[i] + '</span>');
		}

		this.container.style.opacity = '1';

		this.container.innerHTML = spans.join('');

		const timeLine = gsap.timeline({ paused: true });
		timeLine.fromTo( this.container.querySelectorAll('span'), {
			opacity: 0,
			left: '30px',
		},
		{
			opacity: 1,
			left: 0,
			duration: 1,
			delay: delay,
			stagger: {
				each: .035,
				from: 'start',
			},
			ease: 'easeOutExpo',
			onComplete: () => {
				this.container.classList.add('animation-done');
			}
		});
		timeLine.play();

	}


}
